import React from "react";
const GlobalContext = React.createContext({
  isMobile: false,
  experiments: {},
  languageDir: "ltr"
});
export {
  GlobalContext
};
//# sourceMappingURL=contexts.js.map
